import React from 'react';
import ClubExpenseForm from './ClubExpenseForm';

const NewClubExpensePage = () => <ClubExpenseForm formType="create" />;

export default NewClubExpensePage;
